export const GET_TRANSACTIONS_REQUEST = 'GET_TRANSACTIONS_REQUEST';
export const GET_TRANSACTIONS_DATA = 'GET_TRANSACTIONS_DATA';
export const GET_TRANSACTIONS_ERROR = 'GET_TRANSACTIONS_ERROR';

export const UPDATE_QUICK_FILTER = 'UPDATE_QUICK_FILTER';
export const FILTER_TRANSACTIONS = 'FILTER_TRANSACTIONS';
export const SET_TRANSACTIONS_SORT_DATA = 'SET_TRANSACTIONS_SORT_DATA';
export const SORT_TRANSACTIONS = 'SORT_TRANSACTIONS';